import { render, staticRenderFns } from "./UserAuthgroupsAdmin.vue?vue&type=template&id=632e7249&scoped=true&"
import script from "./UserAuthgroupsAdmin.vue?vue&type=script&lang=js&"
export * from "./UserAuthgroupsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthgroupsAdmin.vue?vue&type=style&index=0&id=632e7249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e7249",
  null
  
)

export default component.exports